import { createContext, useContext, type RefObject } from 'react'

/**
 * Lets the comment composer tell the enclosing Sheet "my @-mention popup is
 * open, so swallow the next Escape" — the Sheet's onEscapeKeyDown is the only
 * hook that beats Radix's capture-phase document listener.
 */
export const MentionGuardContext = createContext<RefObject<boolean> | null>(null)

export function useMentionGuard(): RefObject<boolean> | null {
  return useContext(MentionGuardContext)
}
